"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealInfantFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealInfantFilled = function MealInfantFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.121 9.879l.707.707a2 2 0 012.829 0l1.249 1.247c1.966-.569 4.125-.116 5.62 1.38l7.408 7.407c1.487 1.488 1.427 3.96-.135 5.522L25.142 31.8c-1.562 1.562-4.034 1.622-5.522.135l-7.408-7.408c-1.495-1.496-1.948-3.655-1.378-5.622l-1.248-1.247a2 2 0 010-2.829l-.707-.707A3 3 0 1113.12 9.88zm13.435 9.192l-1.414 1.414a1 1 0 001.32 1.498l.094-.084 1.415-1.414-1.415-1.414zm-2.121-2.121l-1.414 1.414a1 1 0 001.32 1.497l.094-.083 1.414-1.414-1.414-1.414zm-2.121-2.122l-1.415 1.415a1 1 0 001.32 1.497l.095-.083 1.414-1.414-1.414-1.415zm-10.607-3.535a1 1 0 00-1.497 1.32l.083.094 1.414 1.414-.707.707a1 1 0 00-.083 1.32l.083.095.707.707 4.243-4.243-.707-.707a1 1 0 00-1.32-.083l-.095.083-.707.707-1.414-1.414z",
    fill: "#97BA1E"
  }));
};

exports.MealInfantFilled = MealInfantFilled;
var _default = MealInfantFilled;
exports.default = _default;